export const TODO_CREATE_REQUEST = "TODO_CREATE_REQUEST";
export const TODO_CREATE_SUCCESS = "TODO_CREATE_SUCCESS";
export const TODO_CREATE_FAIL = "TODO_CREATE_FAIL";

export const TODO_UPDATE_REQUEST = "TODO_UPDATE_REQUEST";
export const TODO_UPDATE_SUCCESS = "TODO_UPDATE_SUCCESS";
export const TODO_UPDATE_FAIL = "TODO_UPDATE_FAIL";

export const TODO_DELETE_REQUEST = "TODO_DELETE_REQUEST";
export const TODO_DELETE_SUCCESS = "TODO_DELETE_SUCCESS";
export const TODO_DELETE_FAIL = "TODO_DELETE_FAIL";

export const TODO_GET_REQUEST = "TODO_GET_REQUEST";
export const TODO_GET_SUCCESS = "TODO_GET_SUCCESS";
export const TODO_GET_FAIL = "TODO_GET_FAIL";
